// extracted by mini-css-extract-plugin
module.exports = {"container":"new-comments_container__2IiHL","header":"new-comments_header__3AA00","title":"new-comments_title__1IgoS","count":"new-comments_count__3NBGt"};